module.exports = __webpack_public_path__ + "static/media/title-typo.2494fa8b.jpg";